var style = {"z-switch":"z-switch","z-switch__track":"z-switch__track"};

export { style as default };
//# sourceMappingURL=Switch.module.scss.js.map
